import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { USER_STATUS_OPTIONS } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable,
    getComparator,
    emptyRows,
    TableNoData,
    TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TablePaginationCustom,
} from 'src/components/table';
import UserTableFiltersResult from './bids-table-filter';
import UserTableRow from './bids-table-row';
import { BidsCreate } from './create-bids-modal';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { applyFilter } from 'src/services/fetching';
import { Box } from '@mui/material';
import { LoadingScreen } from 'src/components/loading-screen';
//

// ----------------------------------------------------------------------

const STATUS_OPTIONS = [ { value: 'all', label: 'All' }, ...USER_STATUS_OPTIONS ];

const TABLE_HEAD = [
    { id: 'name', label: 'Title' },
    { id: 'name', label: 'Links' },
    // { id: 'name', label: 'Actions' },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};
// ----------------------------------------------------------------------

export default function BidsTable() {
    const table = useTable();

    const settings = useSettingsContext();

    const router = useRouter();

    const confirm = useBoolean();
    const add = useBoolean();

    const [ tableData, setTableData ] = useState();
    const [ loading, setLoading ] = useState()
    const [ filters, setFilters ] = useState(defaultFilters);


    useEffect(() => {
        getBids();
    }, []);

    const getBids = async () => {
        setLoading(true)
        const data = await getRequest(`${endpoints.admin_dashboard.teachnical_database.bids.get_list}`);
        if (data) {
            console.log("🚀 ~ getBids ~ data:", data)
            setTableData(data || []);
        }
        setLoading(false)

    };


    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered?.slice(
        table.page * table.rowsPerPage,
        table.page * table.rowsPerPage + table.rowsPerPage
    );

    const denseHeight = table.dense ? 52 : 72;

    const canReset = !isEqual(defaultFilters, filters);

    const notFound = (!dataFiltered?.length && canReset) || !dataFiltered?.length;

    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );



    const handleEditRow = useCallback(
        (id) => {
            router.push(paths.dashboard.user.edit(id));
        },
        [ router ]
    );



    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    return (
        <>
            { loading ? (
                <Box height={ 700 }>
                    <LoadingScreen />
                </Box>
            ) : (
                <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                    <CustomBreadcrumbs
                        heading="Bids"
                        links={ [
                            { name: '', href: paths.dashboard.root },

                        ] }
                        // action={
                        //     <Button
                        //         onClick={ () => add.onTrue() }
                        //         // component={ RouterLink }
                        //         // href={ paths.dashboard.product_user_offers_create }
                        //         variant="contained"
                        //         startIcon={ <Iconify icon="mingcute:add-line" /> }
                        //     >
                        //         Create
                        //     </Button>
                        // }
                        sx={ {
                            mb: { xs: 3, md: 5 },
                        } }
                    />

                    <Card>
                        {/* <Tabs
                        value={ filters.status }
                        onChange={ handleFilterStatus }
                        sx={ {
                            px: 2.5,
                            boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[ 500 ], 0.08)}`,
                        } }
                    >
                        { USER_STATUS_OPTIONS_ROLE.map((tab) => (
                            <Tab
                                key={ tab.value }
                                iconPosition="end"
                                value={ tab.value }
                                label={ tab.label }
                                icon={
                                    <Label
                                        variant={
                                            ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                                        }
                                        color={
                                            (tab.value === 'active' && 'success') ||
                                            (tab.value === 'Inactive' && 'warning') ||
                                            'default'
                                        }
                                    >
                                        { tab.value === 'all' && _userList.length }
                                        { tab.value === 'active' &&
                                            _userList.filter((user) => user.status === 'active').length }
                                        { tab.value === 'inactive' &&
                                            _userList.filter((user) => user.status === 'inactive').length }
                                    </Label>
                                }
                            />
                        )) }
                    </Tabs> */}

                        {/* <UserTableToolbar
                        filters={ filters }
                        onFilters={ handleFilters }
                        roleOptions={ _roles }
                    /> */}

                        { canReset && (
                            <UserTableFiltersResult
                                filters={ filters }
                                onFilters={ handleFilters }
                                //
                                onResetFilters={ handleResetFilters }
                                //
                                results={ dataFiltered?.length }
                                sx={ { p: 2.5, pt: 0 } }
                            />
                        ) }

                        <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                            <TableSelectedAction
                                dense={ table.dense }
                                numSelected={ table?.selected?.length }
                                rowCount={ tableData?.length }
                                onSelectAllRows={ (checked) =>
                                    table.onSelectAllRows(
                                        checked,
                                        tableData.map((row) => row.id)
                                    )
                                }
                                action={
                                    <Tooltip title="Delete">
                                        <IconButton color="primary" onClick={ confirm.onTrue }>
                                            <Iconify icon="solar:trash-bin-trash-bold" />
                                        </IconButton>
                                    </Tooltip>
                                }
                            />

                            <Scrollbar>
                                <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                    <TableHeadCustom
                                        order={ table.order }
                                        orderBy={ table.orderBy }
                                        headLabel={ TABLE_HEAD }
                                        rowCount={ tableData?.length }
                                        numSelected={ table?.selected?.length }
                                        onSort={ table.onSort }
                                        onSelectAllRows={ (checked) =>
                                            table.onSelectAllRows(
                                                checked,
                                                tableData.map((row) => row.id)
                                            )
                                        }
                                    />

                                    <TableBody>
                                        { dataFiltered
                                            ?.slice(
                                                table.page * table.rowsPerPage,
                                                table.page * table.rowsPerPage + table.rowsPerPage
                                            )
                                            .map((row) => (
                                                <UserTableRow
                                                    key={ row.id }
                                                    row={ row }
                                                    selected={ table.selected.includes(row.id) }
                                                    // onSelectRow={ () => table.onSelectRow(row.id) }
                                                    // onDeleteRow={ () => handleDeleteRow(row.id) }
                                                    onEditRow={ () => handleEditRow(row.id) }
                                                />
                                            )) }

                                        <TableEmptyRows
                                            height={ denseHeight }
                                            emptyRows={ emptyRows(table.page, table.rowsPerPage, tableData?.length) }
                                        />

                                        <TableNoData notFound={ notFound } />
                                    </TableBody>
                                </Table>
                            </Scrollbar>
                        </TableContainer>

                        <TablePaginationCustom
                            count={ dataFiltered?.length }
                            page={ table.page }
                            rowsPerPage={ table.rowsPerPage }
                            onPageChange={ table.onChangePage }
                            onRowsPerPageChange={ table.onChangeRowsPerPage }
                            //
                            dense={ table.dense }
                            onChangeDense={ table.onChangeDense }
                        />
                    </Card>
                </Container>
            ) }
            <BidsCreate
                open={ add.value } onClose={ add.onFalse }
            // reload={()=>{}}
            />
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

